// extracted by mini-css-extract-plugin
export default {"myDataview":"styles_myDataview__TxTf6"};